import type { AdapterOption, ScannerInfo } from '@/api/types'

/**
 * The options a scanner accepts for a given source type.
 *
 * A scanner can serve several source types without accepting the same options
 * for all of them — the network scanner drives a live probe for one and reads
 * a capture file for another, and each mode takes a different set of flags.
 * An option declares its scope in `applies_to`; an empty or absent one means
 * it applies everywhere.
 *
 * The API rejects an option set on a source type it does not apply to, so
 * filtering here is what keeps the form from offering a field that cannot be
 * saved.
 */
export function optionsForSourceType(
  options: AdapterOption[] | undefined,
  sourceType: string,
): AdapterOption[] {
  if (!options) return []
  return options.filter((o) => !o.applies_to?.length || o.applies_to.includes(sourceType))
}

/** Convenience wrapper for a whole scanner. */
export function scannerOptionsFor(scanner: ScannerInfo, sourceType: string): AdapterOption[] {
  return optionsForSourceType(scanner.options, sourceType)
}
